import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=7a33774f&scoped=true&"
import script from "./orderDetail.vue?vue&type=script&lang=js&"
export * from "./orderDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=7a33774f&prod&lang=less&"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=7a33774f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a33774f",
  null
  
)

export default component.exports